export default {
	install(Vue) {
		Vue.prototype.liveconfig = function(callback) {
			if(sessionStorage.getItem('shopconfig')){
				var shopconfig  = JSON.parse(sessionStorage.getItem('shopconfig'))
				callback(shopconfig);
			}else{
				this.$axios({
					url: this.$store.state.p_url + 'service/config/LiveConfig',
					method: "POST",
					data: {},
					
				}).then(res => {
					callback(res);
					if(Number(res.data.code)==200){
						sessionStorage.setItem('shopconfig',JSON.stringify(res));
					}
				})
			}
		}
	}
}


// WEBPACK FOOTER //
// ./src/assets/js/livecon.js